const state = { mega_menu: false};
const actions = {
    show: ({ commit }) => {
        return new Promise(() => {
            commit("show");
        });
    },
    hide: ({ commit }) => {
        return new Promise(() => {
            commit("hide");
        });
    }
};
const mutations = {
    show: (state) => {
        state.mega_menu = true;
    },
    hide: (state) => {
        state.mega_menu = false;
    }
};
const getters = {
    isShow: (state) => state.mega_menu,
};
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};